// Check if is RTL
const isRTL = getComputedStyle(document.body).direction === "rtl";

// Carousel multiple
let items = document.querySelectorAll(".carousel-multi .carousel-item");

items.forEach((el, index) => {
	// Número de diapositivas por elemento de carrusel
	const minPerSlide = 3;
	let prevIndex = index - 1;
	let next = el.nextElementSibling;

	for (var i = 1; i < minPerSlide; i++) {
		if (isRTL) {
			if (prevIndex < 0) {
				// Envolver el carrusel usando el último hijo
				prevIndex = items.length - 1;
			}

			let cloneChild = items[prevIndex].querySelector(".locationcard").cloneNode(true);
			el.appendChild(cloneChild);
			prevIndex--;
		} else {
			if (!next) {
				// wrap carousel by using first child
				next = items[0];
			}
			let cloneChild = next.cloneNode(true);
			el.appendChild(cloneChild.children[0]);
			next = next.nextElementSibling;
		}
	}
});

/**
 *
 * GSAP
 */

gsap.registerPlugin(ScrollTrigger);

/**
 * NAVBAR
 */

// Hide on scroll
if (document.querySelector(".navbar")) {
	const showNavbar = gsap
		.from("#main-nav", {
			yPercent: -100,
			paused: true,
			duration: 0.3,
		})
		.progress(1);

	ScrollTrigger.create({
		start: "top top",
		end: 99999,
		onUpdate: (self) => {
			self.direction === -1 ? showNavbar.play() : showNavbar.reverse();
		},
	});

	// Collapse menu
	const navbarToggler = document.querySelector(".navbar-toggler"); // Button
	const navbarCollapse = document.querySelector("#navbarNavDropdown"); // Collapsed menu
	const navbarMenu = document.querySelector("#main-menu"); // White box with links
	const htmlDir = document.documentElement.getAttribute("dir");

	// Click in Toggler button
	if (navbarToggler && navbarCollapse && navbarMenu) {
		navbarToggler.addEventListener("click", function () {
			if (navbarToggler.classList.contains("collapsed")) {
				// Hide menu
				gsap.to(navbarCollapse, { autoAlpha: 0, duration: 0.5, ease: "power4.out" });
				gsap.to(navbarMenu, { x: htmlDir === "rtl" ? "-100%" : "100%", duration: 1.5, ease: "power4.out" });
				document.body.classList.remove("no-scroll"); // Allow scroll
			} else {
				// Show menu
				gsap.to(navbarCollapse, { autoAlpha: 1, duration: 0.5, ease: "power4.out" });
				gsap.to(navbarMenu, { x: "0%", duration: 1.5, ease: "power4.out" });
				document.body.classList.add("no-scroll"); // No scroll
			}
		});

		// Click in Collapse (when is open)
		navbarCollapse.addEventListener("click", function (e) {
			if (this === e.target) {
				if (!navbarToggler.classList.contains("collapsed")) {
					// Hide menu
					gsap.to(navbarCollapse, { autoAlpha: 0, duration: 0.5, ease: "power4.out" });
					gsap.to(navbarMenu, { x: htmlDir === "rtl" ? "-100%" : "100%", duration: 1.5, ease: "power4.out" });
					document.body.classList.remove("no-scroll"); // Allow scroll
					navbarToggler.classList.add("collapsed");
				}
			}
		});
	}
}

/**
 * HEADER ANIMATION
 */

if (document.querySelector(".header")) {
	if (document.querySelector(".header__title")) {
		gsap.from(".header__title", {
			y: 80,
			autoAlpha: 0,
			duration: 2,
			delay: 0.1,
			ease: "power4.out",
		});
	}
	if (document.querySelector(".header__subtitle")) {
		gsap.from(".header__subtitle", {
			y: 120,
			autoAlpha: 0,
			duration: 2,
			ease: "power4.out",
			delay: 0.3,
		});
	}
	if (document.querySelector(".header__image")) {
		gsap.from(".header__image", {
			autoAlpha: 0,
			duration: 2,
			delay: 0.3,
			ease: "power4.out",
		});
	}
	if (document.querySelector(".header__content")) {
		gsap.from(".header__content", {
			autoAlpha: 0,
			duration: 2,
			delay: 0.3,
			ease: "power4.out",
		});
	}
}

/**
 * SECTION HEADER ANIMATION
 */

if (document.querySelector(".fadeHeader")) {
	let fadeHeaders = document.querySelectorAll(".fadeHeader");

	fadeHeaders.forEach((header) => {
		if (header.querySelector(".fadeTitle")) {
			gsap.from(header.querySelector(".fadeTitle"), {
				scrollTrigger: {
					trigger: header,
					start: "30% bottom",
				},
				y: 80,
				autoAlpha: 0,
				duration: 1.8,
				ease: "power4.out",
			});
		}
		if (header.querySelector(".fadeSubtitle")) {
			gsap.from(header.querySelector(".fadeSubtitle"), {
				scrollTrigger: {
					trigger: header,
					start: "30% bottom",
				},
				y: 100,
				autoAlpha: 0,
				duration: 2,
				ease: "power4.out",
			});
		}
		if (header.querySelector(".fadeContentLeft")) {
			gsap.from(header.querySelector(".fadeContentLeft"), {
				scrollTrigger: {
					trigger: header,
					start: "30% bottom",
				},
				y: 120,
				autoAlpha: 0,
				duration: 2.1,
				ease: "power4.out",
			});
		}
		if (header.querySelector(".fadeContent")) {
			gsap.from(header.querySelector(".fadeContent"), {
				scrollTrigger: {
					trigger: header,
					start: "30% bottom",
				},
				y: 120,
				autoAlpha: 0,
				duration: 2.2,
				ease: "power4.out",
			});
		}
	});
}

/**
 * FADE ANIMATION
 */

// Individual
if (document.querySelector(".fadeIn")) {
	const fadeIn = gsap.utils.toArray(".fadeIn");
	fadeIn.forEach((element, i) => {
		const anim = gsap.from(element, { autoAlpha: 0, y: 150, duration: 2.5, ease: "power4.out" });

		ScrollTrigger.create({
			trigger: element,
			animation: anim,
			start: "30% bottom",
		});
	});
}

if (document.querySelector(".fadeOut")) {
	const fadeIn = gsap.utils.toArray(".fadeOut");
	fadeIn.forEach((element, i) => {
		const anim = gsap.to(element, { autoAlpha: 0, duration: 4, ease: "power4.out" });

		ScrollTrigger.create({
			trigger: element,
			animation: anim,
			start: "10% 10%",
			markers: true,
		});
	});
}

// Fade in Steps
if (document.querySelector(".fadeInSteps")) {
	let fadeInSteps = document.querySelectorAll(".fadeInSteps");

	fadeInSteps.forEach((step) => {
		let tl = gsap.timeline().pause(); // Pause the timeline immediately after creating it

		tl.staggerFrom(
			step.children,
			1,
			{
				autoAlpha: 0,
				y: 120,
				duration: 2,
				ease: "power4.out",
			},
			0.15
		);

		ScrollTrigger.create({
			trigger: step,
			start: "30% bottom",
			onEnter: () => tl.play(), // Play the timeline when entering the trigger
			once: true, // The trigger will only occur once
		});

		if (ScrollTrigger.isPastScrollEnd) {
			// If we're already past the trigger point on page load, force the timeline to play
			tl.play();
		}
	});
}

// Media
if (document.querySelector(".fadeImage")) {
	let fadeImage = document.querySelectorAll(".fadeImage");
	fadeImage.forEach((container) => {
		let media = container.querySelector("img, video");
		let tl = gsap.timeline({
			scrollTrigger: {
				trigger: container,
				start: "-100% bottom-=20%",
			},
		});

		tl.set(container, { autoAlpha: 1 });
		tl.from(container, 1.5, {
			yPercent: 100,
			ease: Power4.out,
		});
		tl.from(media, 1.5, {
			yPercent: -100,
			delay: -1.5,
			ease: Power4.out,
		});
	});
}

if (document.querySelector(".fadeBgImage")) {
	let fadeBgImage = document.querySelectorAll(".fadeBgImage");
	fadeBgImage.forEach((container) => {
		let media = container.querySelector("img, video");
		let tl = gsap.timeline({
			scrollTrigger: {
				trigger: container,
				start: "-100% bottom-=20%",
			},
		});

		tl.set(container, { autoAlpha: 1, scale: 1 });
		tl.to(container, 3, {
			scale: 1.2,
			ease: Power4.out,
		});

		tl.from(media, 3, {
			scale: 1,
			delay: -1.5,
			ease: Power4.out,
		});
	});
}

// LOGOS CAROUSEL
if (document.querySelector(".logosCarousel")) {
	const target = document.querySelector(".logosCarousel");
	const clone = target.cloneNode(true);
	target.after(clone);

	if (isRTL) {
		gsap.to(".logosCarousel", {
			xPercent: 100,
			ease: "none",
			duration: 20,
			repeat: -1,
		});
	} else {
		gsap.to(".logosCarousel", {
			xPercent: -100,
			ease: "none",
			duration: 20,
			repeat: -1,
		});
	}
}

// Image overlap fade out
if (document.querySelector(".cp-background-image__overlap")) {
	document.addEventListener("DOMContentLoaded", function () {
		gsap.registerPlugin(ScrollTrigger);

		gsap.to(".cp-background-image__overlap", {
			scrollTrigger: {
				trigger: ".cp-background-image__overlap",
				start: "25% center",
				end: "60% center",
				scrub: true,
			},
			opacity: 0, // Desvanece el elemento
			duration: 1, // Duración de la animación
		});
	});
}

// Refresh on Lazy loading

document.querySelectorAll("img").forEach((img) => {
	if (img.complete) {
		ScrollTrigger.refresh();
	} else {
		img.addEventListener("load", (imgLoaded) => ScrollTrigger.refresh());
	}
});

/**
 *
 *
 *
 * LOTTIE
 */

/**
 * Arrows Headers
 */

// A function of the page headers arrows. Only the ID container & file change
function headerAnimation(idContainer, fileName) {
	const basePath = "/wp-content/themes/understrap-child/animations/";

	let anim = lottie.loadAnimation({
		container: document.getElementById(idContainer),
		path: basePath + fileName,
		renderer: "svg",
		loop: false,
		autoplay: true,
	});

	function loop() {
		anim.playSegments([31, 90], true); // frames of loops
	}
	anim.addEventListener("complete", loop);
	return anim;
}

headerAnimation("arrowApproach", "arrow-approach.json");
headerAnimation("arrowLeadership", "arrow-leadership.json");
headerAnimation("arrowAboutus", "arrow-solutions.json");
headerAnimation("arrowSolutions", "arrow-solutions.json");
headerAnimation("arrowServices", "arrow-services.json");
headerAnimation("arrowProducts", "arrow-products.json");
headerAnimation("arrowParkpass", "arrow-parkpass.json");
headerAnimation("arrowHorizontalRtl", "arrow-horizontal-rtl.json");

/**
 * ArrowCTA
 */

if (document.querySelector(".arrowCTA")) {
	let arrowCTAs = document.getElementsByClassName("arrowCTA");
	for (let i = 0; i < arrowCTAs.length; i++) {
		let animation = lottie.loadAnimation({
			container: arrowCTAs[i],
			path: "/wp-content/themes/understrap-child/animations/arrow-cta.json",
			renderer: "svg",
			loop: true,
			autoplay: true,
		});
	}
}

// Arrow box Academy
if (document.getElementById("arrowBoxAcademy")) {
	let arrowBoxAcademy = lottie.loadAnimation({
		container: document.getElementById("arrowBoxAcademy"),
		path: "/wp-content/themes/understrap-child/animations/arrow-box-academy.json",
		renderer: "svg",
		loop: true,
		autoplay: true,
	});
}

//Arrow box Approach
if (document.getElementById("arrowBoxApproach")) {
	let arrowBoxApproach = lottie.loadAnimation({
		container: document.getElementById("arrowBoxApproach"),
		path: "/wp-content/themes/understrap-child/animations/arrow-box-approach.json",
		renderer: "svg",
		loop: true,
		autoplay: true,
		filterSize: {
			width: "200%",
			height: "200%",
			x: "-50%",
			y: "-50%",
		},
	});
}
//Arrow box Leadership
if (document.getElementById("arrowBoxLeadership")) {
	let arrowBoxApproach = lottie.loadAnimation({
		container: document.getElementById("arrowBoxLeadership"),
		path: "/wp-content/themes/understrap-child/animations/arrow-box-leadership.json",
		renderer: "svg",
		loop: true,
		autoplay: true,
	});
}

//Scroll arrow
if (document.getElementById("scrollArrow")) {
	let scrollArrow = lottie.loadAnimation({
		container: document.getElementById("scrollArrow"),
		path: "/wp-content/themes/understrap-child/animations/scrollarrow.json",
		renderer: "svg",
		loop: true,
		autoplay: true,
	});
}

//Home Approach
if (document.getElementById("homeApproach")) {
	let arrowBoxApproach = lottie.loadAnimation({
		container: document.getElementById("homeApproach"),
		path: "/wp-content/themes/understrap-child/animations/arrow-approach-home.json",
		renderer: "svg",
		loop: true,
		autoplay: true,
	});
}

//Home Approach
if (document.getElementById("verticalArrow")) {
	let arrowBoxApproach = lottie.loadAnimation({
		container: document.getElementById("verticalArrow"),
		path: "/wp-content/themes/understrap-child/animations/vertical-arrow.json",
		renderer: "svg",
		loop: true,
		autoplay: true,
	});
}

/**
 * Animations
 */

// A function of the page headers arrows. Only the ID container & file change
function iconAnimation(idContainer, fileName) {
	const basePath = "/wp-content/themes/understrap-child/animations/";

	let anim = lottie.loadAnimation({
		container: document.getElementById(idContainer),
		path: basePath + fileName,
		renderer: "svg",
		loop: true,
		autoplay: true,
	});
}

iconAnimation("car-parking", "car-parking.json");
iconAnimation("icon-forward", "icons/forward.json");
iconAnimation("icon-partnership", "icons/partnership.json");
iconAnimation("icon-user-experience", "icons/user-experience.json");
iconAnimation("icon-user-experience-2", "icons/user-experience.json");
iconAnimation("icon-diligence", "icons/diligence.json");
iconAnimation("icon-diligence-2", "icons/diligence.json");
iconAnimation("icon-leadership-large", "icons/leadership-large.json");
iconAnimation("icon-leadership-large-2", "icons/leadership-large.json");
iconAnimation("icon-quickpay", "icons/quickpay.json");
